import HQChart from 'hqchart'
import { quoteColors } from './quoteColors'

export function applyChartTheme(chart, theme) {
  const { JSChart, HQChartStyle, STYLE_TYPE_ID } = HQChart.Chart
  const style = theme === 'light' ? STYLE_TYPE_ID.WHITE_ID : STYLE_TYPE_ID.BLACK_ID
  JSChart.SetStyle(HQChartStyle.GetStyleConfig(style))
  const resource = JSChart.GetResource()
  const colors = quoteColors(theme)
  resource.UpBarColor = resource.UpTextColor = colors.up
  resource.DownBarColor = resource.DownTextColor = colors.down
  resource.UnchagneBarColor = resource.UnchagneTextColor = colors.flat
  if (resource.FrameLatestPrice) {
    resource.FrameLatestPrice.UpBarColor = colors.up
    resource.FrameLatestPrice.DownBarColor = colors.down
  }
  if (resource.IndexTitle && resource.IndexTitle.UpDownArrow) {
    resource.IndexTitle.UpDownArrow.UpColor = colors.up
    resource.IndexTitle.UpDownArrow.DownColor = colors.down
  }
  if (!resource.FrameLogo || typeof resource.FrameLogo !== 'object') {
    resource.FrameLogo = { ...HQChartStyle.GetStyleConfig(STYLE_TYPE_ID.WHITE_ID).FrameLogo }
  }
  resource.FrameLogo.Text = null
  if (chart) chart.ReloadResource({ Resource: resource, Draw: true })
}
